import React from "react";

export const UploadCircleIcon = ({ width = 40, height = 40, color = "#595959", bg = "#F5F5F5" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill={bg}
    />
    <path
      d="M15.9845 10.4219L16.0528 10.4251C16.0669 10.4266 16.0807 10.4293 16.0945 10.4316C16.1012 10.4328 16.108 10.4336 16.1147 10.4349C16.123 10.4365 16.1312 10.4388 16.1394 10.4408C16.1525 10.4439 16.1656 10.4466 16.1785 10.4505C16.1915 10.4545 16.2042 10.4595 16.2169 10.4642C16.2234 10.4666 16.23 10.4687 16.2364 10.4714C16.2468 10.4756 16.2569 10.4803 16.267 10.485C16.2968 10.499 16.3257 10.5153 16.3536 10.5339C16.3904 10.5584 16.4247 10.5861 16.4558 10.6172L20.4558 14.6172C20.7162 14.8775 20.7161 15.2995 20.4558 15.5599C20.1955 15.8202 19.7735 15.8202 19.5131 15.5599L16.6511 12.6979V20.4219C16.6511 20.79 16.3526 21.0885 15.9845 21.0885C15.6163 21.0885 15.3178 20.7901 15.3178 20.4219V12.6979L12.4558 15.5599C12.1955 15.8202 11.7735 15.8202 11.5131 15.5599C11.2528 15.2995 11.2528 14.8775 11.5131 14.6172L15.5131 10.6172C15.5586 10.5718 15.6105 10.5328 15.6674 10.502C15.6766 10.497 15.6861 10.4928 15.6954 10.4883C15.7256 10.4737 15.7567 10.4605 15.7892 10.4505C15.8027 10.4464 15.8165 10.4434 15.8302 10.4401C15.8377 10.4383 15.8453 10.4364 15.853 10.4349L15.8569 10.4342L15.9161 10.4251C15.9386 10.4228 15.9614 10.4219 15.9845 10.4219Z"
      fill={color}
    />
  </svg>
);

